module.exports = __webpack_public_path__ + "static/img/logo.8b3d205a.png";